import { isLocal } from "./isLocal";
import { isProduction } from "./isProduction";
import { isStaging } from "./isStaging";
/**
 * Helper function for performing a succinct switch statement for the current env.
 *
 * @example
 * ```
 * const nameWithEnv = getForEnv({
 *   defaultValue: "Faire",
 *   local: "Faire (Localhost)",
 *   staging: "Faire (Staging)",
 *   production: "Faire (Production)"
 * });
 * ```
 */ export var getForEnv = function(param) {
    var defaultValue = param.defaultValue, production = param.production, staging = param.staging, local = param.local;
    if (production && isProduction()) {
        return production;
    }
    if (staging && isStaging()) {
        return staging;
    }
    if (local && isLocal()) {
        return local;
    }
    return defaultValue;
};
